const PreLoader = () => {
  return (
    <div className="preloader">
      <div className="loader">
        <div className="pre-shadow" />
        <div className="pre-box" />
      </div>
    </div>
  );
};
export default PreLoader;
